export default "__VITE_ASSET__DsrcSHOo__"